/*
 * Printeo — visionneuse de photos (lot C, snippet pt-visionneuse). Vanilla, chargé en defer.
 *
 * - Un clic sur un lien [data-pt-agrandir] agrandit la photo dans la fenêtre <dialog> de la page,
 *   au lieu d'ouvrir l'image : croix, touche Échap, clic à côté de la photo pour fermer.
 * - Les liens qui partagent data-pt-groupe forment une suite : flèches et touches ← →.
 * - Clic avec Ctrl, Cmd, Maj, Alt ou bouton du milieu : comportement normal du lien.
 * - À la fermeture, le focus revient sur la vignette ; l'anneau de focus n'apparaît que si la
 *   photo a été ouverte au clavier (focus({ focusVisible })).
 * - Les liens créés plus tard (pages d'avis suivantes) fonctionnent aussi : écoute déléguée.
 * Aucun texte affiché n'est écrit ici : tout vient des attributs rendus par le snippet.
 */
(() => {
  'use strict';

  const PT = (window.PT = window.PT || {});
  if (PT.visionneuse) return;

  let dialogue = null;
  let image = null;
  let compteur = null;
  let boutonsPas = [];
  let groupe = [];
  let index = 0;
  let declencheur = null;
  let auClavier = false;

  function preparer() {
    if (dialogue) return true;
    const candidat = document.querySelector('[data-pt-visionneuse]');
    if (!candidat || typeof candidat.showModal !== 'function') return false;
    dialogue = candidat;
    // L'image n'existe qu'à la première ouverture : aucune image vide dans la page avant.
    image = document.createElement('img');
    image.className = 'pt-visionneuse__image';
    image.decoding = 'async';
    dialogue.querySelector('[data-pt-visionneuse-cadre]').prepend(image);
    compteur = dialogue.querySelector('[data-pt-visionneuse-compteur]');
    boutonsPas = Array.from(dialogue.querySelectorAll('[data-pt-visionneuse-pas]'));

    dialogue.querySelector('[data-pt-visionneuse-fermer]').addEventListener('click', () => dialogue.close());
    boutonsPas.forEach((bouton) => {
      bouton.addEventListener('click', () => afficher(index + Number(bouton.dataset.ptVisionneusePas)));
    });
    // Clic à côté de la photo (fond de la fenêtre ou du cadre) : fermeture.
    dialogue.addEventListener('click', (evenement) => {
      if (evenement.target === dialogue || evenement.target.hasAttribute('data-pt-visionneuse-cadre')) dialogue.close();
    });
    dialogue.addEventListener('keydown', (evenement) => {
      if (groupe.length < 2) return;
      if (evenement.key === 'ArrowLeft') { evenement.preventDefault(); afficher(index - 1); }
      if (evenement.key === 'ArrowRight') { evenement.preventDefault(); afficher(index + 1); }
    });
    dialogue.addEventListener('close', () => {
      document.documentElement.classList.remove('pt-visionneuse-ouverte');
      if (declencheur && document.contains(declencheur)) {
        // Navigateurs qui ignorent focusVisible : la classe retire l'anneau jusqu'à la sortie.
        if (!auClavier) {
          const cible = declencheur;
          cible.classList.add('pt-focus-souris');
          cible.addEventListener('blur', () => cible.classList.remove('pt-focus-souris'), { once: true });
        }
        try {
          declencheur.focus({ preventScroll: true, focusVisible: auClavier });
        } catch (erreur) {
          declencheur.focus();
        }
      }
      declencheur = null;
    });
    return true;
  }

  function afficher(nouvelIndex) {
    if (!groupe.length) return;
    index = (nouvelIndex + groupe.length) % groupe.length;
    const lien = groupe[index];
    image.classList.remove('pt-visionneuse__image--prete');
    image.alt = lien.dataset.alt || '';
    const montrer = () => image.classList.add('pt-visionneuse__image--prete');
    image.onload = montrer;
    image.onerror = montrer;
    image.src = lien.href;
    if (image.complete && image.naturalWidth) montrer();
    const plusieurs = groupe.length > 1;
    boutonsPas.forEach((bouton) => { bouton.hidden = !plusieurs; });
    if (compteur) {
      compteur.hidden = !plusieurs;
      if (plusieurs) {
        compteur.textContent = (compteur.dataset.modele || '')
          .split('[n]').join(String(index + 1))
          .split('[t]').join(String(groupe.length));
      }
    }
  }

  function ouvrir(lien, clavier) {
    if (!preparer()) return false;
    const nom = lien.dataset.ptGroupe;
    groupe = nom
      ? Array.from(document.querySelectorAll('a[data-pt-agrandir]')).filter((a) => a.dataset.ptGroupe === nom)
      : [lien];
    if (!groupe.includes(lien)) groupe = [lien];
    declencheur = lien;
    auClavier = Boolean(clavier);
    afficher(Math.max(0, groupe.indexOf(lien)));
    document.documentElement.classList.add('pt-visionneuse-ouverte');
    dialogue.showModal();
    return true;
  }

  document.addEventListener('click', (evenement) => {
    const lien = evenement.target.closest('a[data-pt-agrandir]');
    if (!lien || evenement.button !== 0 || evenement.ctrlKey || evenement.metaKey || evenement.shiftKey || evenement.altKey) return;
    // detail === 0 : clic déclenché au clavier (Entrée) et non à la souris ou au doigt.
    if (ouvrir(lien, evenement.detail === 0)) evenement.preventDefault();
  });

  PT.visionneuse = { ouvrir };
})();
